import { styled } from '@mui/material';
import { Box } from 'shared/mui/Box';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';

export const StyledMappingCardContent = styled(CardContent)({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  padding: '24px 0 0 0 !important',
  gap: '24px',
});

export const StyledFormContent = styled(Box)({
  gap: '24px',
  display: 'flex',
  alignItems: 'flex-start',
  padding: '24px 0 0 0',
  alignSelf: 'stretch',
});

export const StyledContent = styled(Box)({
  width: '100%',
  paddingTop: '16px',
});
